module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.List && _vm.List.length) ? _c('div', {
    staticClass: "w5-vds-plan-list-filter-wrapper plan"
  }, [_c('div', {
    staticClass: "w5-vds-plan-list-block"
  }, _vm._l((_vm.List), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "w5-vds-plan-list-item outer-disks",
      class: {
        'selected': item.id == _vm.curValue.id
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.onClick(item)
        }
      }
    }, [_c('div', {
      staticClass: "w5-vds-plan-list-item-up"
    }, [_c('img', {
      staticClass: "local-group disks",
      class: {
        'selected': item.id == _vm.curValue.id, 'macloud': _vm.AppName === 'macloud'
      },
      attrs: {
        "src": item.img
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "w5-vds-plan-list-item-down"
    }, [_c('strong', [_vm._v(_vm._s(item.name))])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.Description)),
      expression: "localeFtc(Description)"
    }]
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41af8c3a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/outerdisktype.vue
// module id = 439
// module chunks = 0